'use client'

import { useCallback, useState } from 'react'
import Image from 'next/image'

import { Icon, IconComponent } from '@graftcode/design-system'

import { VIDEOS_TEST_IDS } from '../../videos.const'

import styles from './YouTubeEmbed.module.scss'

type YouTubeEmbedProps = {
  youtubeVideoId: string
  title: string
  thumbnailUrl: string
}

export function YouTubeEmbed({ youtubeVideoId, title, thumbnailUrl }: YouTubeEmbedProps) {
  const [isPlaying, setIsPlaying] = useState(false)

  const handlePlay = useCallback(() => setIsPlaying(true), [])

  const embedSrc = `https://www.youtube-nocookie.com/embed/${youtubeVideoId}?rel=0&autoplay=1`

  if (isPlaying) {
    return (
      <div className={styles.player} data-testid={VIDEOS_TEST_IDS.youtubeEmbed}>
        <iframe
          src={embedSrc}
          title={title}
          className={styles.iframe}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
    )
  }

  return (
    <button type="button" className={styles.facade} onClick={handlePlay} aria-label={`Play ${title}`}>
      <Image
        src={thumbnailUrl}
        alt=""
        fill
        className={styles.thumbnail}
        sizes="(min-width: 64rem) 56rem, 100vw"
        unoptimized={thumbnailUrl.startsWith('https://')}
      />
      <span className={styles.playButton}>
        <IconComponent icon={Icon.PlayFilled} />
      </span>
    </button>
  )
}
